export type CttCodeWindowStatus = "Active" | "NotYetActive" | "Expired";

/** Mirrors OnlineTestAPI3 CttCodeWindowRules.Classify / API Status strings. */
export function classifyCttCodeStatus(
  startUtc: string,
  endUtc: string,
  now: Date = new Date()
): CttCodeWindowStatus {
  if (startUtc && new Date(startUtc) > now) return "NotYetActive";
  if (endUtc && new Date(endUtc) < now) return "Expired";
  return "Active";
}

/**
 * Apply list/edit Active checkbox semantics.
 * currentlyActive true → deactivate; false → reactivate.
 * Empty strings mean cleared (null) datetimes for the API.
 */
export function applyCttCodeActiveToggle(
  startUtc: string,
  endUtc: string,
  currentlyActive: boolean,
  now: Date = new Date()
): { startUtc: string; endUtc: string } {
  const nowIso = now.toISOString();
  if (currentlyActive) {
    return { startUtc, endUtc: nowIso };
  }
  const startMissing = !startUtc;
  const startIsFuture = !!startUtc && new Date(startUtc) > now;
  return {
    startUtc: startMissing || startIsFuture ? nowIso : startUtc,
    endUtc: "",
  };
}

export function cttCodeDatesForApi(startUtc: string, endUtc: string): {
  startDateTime: string | null;
  endDateTime: string | null;
} {
  return {
    startDateTime: startUtc || null,
    endDateTime: endUtc || null,
  };
}
